export default __webpack_public_path__ + "static/media/bind.e9b67d18.png";